import React from 'react'
import SoftBox from '../softBox'
import { Typography } from '@mui/material'

export const Loader = () => {
    return (
        <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh">
            <Typography variant="h6">Loading details...</Typography>
        </SoftBox>
    )
}
